const mergeMessages = modules =>
  // Default translations will be overwritten by subsequent language specific strings for the same
  // keys. Any key that is missing from a language will use the default languange value
  modules.reduce((acc, val) => {
    const translationEntries = {
      ...acc,
    };

    Object.keys(val).forEach(key => {
      // filter out warnings about missing translations
      // eg.  "!!!   Needs translation from en locale: `On-Call Reminder Start Shift`  !!!"
      if (!/!!!.*!!!/.test(val[key])) {
        translationEntries[key] = val[key];
      }
    });

    return translationEntries;
  }, {});

export default mergeMessages;
